import React, { useState } from 'react';
import { SKIN_COLORS, COSMETICS, GADGETS, PETS, TRAILS, AURAS, SKINS } from '../game/config';
import SkinPreview from './SkinPreview';

const HAT_EMOJI = { none: '', cap: '🧢', beanie: '🧶', crown: '👑', party: '🎉', ninja: '🥷', halo: '😇', top: '🎩', chef: '🧑‍🍳', wizard: '🧙', alien: '👽', devil: '😈', cowboy: '🤠', grad: '🎓', flower: '🌸', star: '⭐', skull: '💀', viking: '⛑️', unicorn: '🦄', robot: '🤖', pumpkin: '🎃', gift: '🎁', headphones: '🎧', sprout: '🌱', firehat: '🔥' };
const toList = (obj) => Object.entries(obj).map(([id, v]) => ({ id, ...v }));

const CATS = [
  { key: 'skins', label: '⭐ Legends', field: 'skin', items: toList(SKINS) },
  { key: 'hats', label: 'Hats', field: 'hat', items: COSMETICS.hats },
  { key: 'color', label: 'Colors', field: 'color', free: true },
  { key: 'trails', label: 'Trails', field: 'trail', items: toList(TRAILS) },
  { key: 'auras', label: 'Auras', field: 'aura', items: toList(AURAS) },
  { key: 'effects', label: 'Effects', field: 'effect', items: COSMETICS.effects },
  { key: 'gadgets', label: 'Gadgets', field: 'gadget', items: toList(GADGETS) },
  { key: 'pets', label: 'Pets', field: 'pet', items: toList(PETS) },
];

export default function Customize({ profile, onChange, onBack }) {
  const [tab, setTab] = useState('hats');
  const owned = profile.owned || {};
  const cat = CATS.find((c) => c.key === tab);

  const isOwned = (key, id) => (owned[key] || []).includes(id);
  const buy = (key, field, item) => {
    if (isOwned(key, item.id)) { onChange({ [field]: item.id }); return; }
    if (item.exclusive) return; // store-only, can't be bought with coins
    if ((profile.coins || 0) < item.price) return;
    const nextOwned = { ...owned, [key]: [...(owned[key] || []), item.id] };
    onChange({ coins: profile.coins - item.price, owned: nextOwned, [field]: item.id });
  };

  return (
    <div className="so-menu" data-testid="customize-screen">
      <div className="so-menu-bg" />
      <div className="so-customize so-shop">
        <div className="so-shop-head">
          <button className="so-back" onClick={onBack} data-testid="customize-back">‹ Back</button>
          <span className="so-coins" data-testid="coin-balance">🪙 {profile.coins || 0}</span>
        </div>
        <h2>Insane Shop</h2>

        <div className="so-preview">
          <div className="so-preview-char">
            <div className="so-preview-hat">{HAT_EMOJI[profile.hat] || ''}</div>
            <div className="so-preview-body-wrap" style={{ boxShadow: AURAS[profile.aura]?.color ? `0 0 30px ${AURAS[profile.aura].color}` : 'none' }}>
              <SkinPreview skin={profile.skin} color={profile.color} />
            </div>
            {profile.pet !== 'none' && <div className="so-preview-pet">{PETS[profile.pet]?.icon}</div>}
          </div>
          <div className="so-preview-name">{profile.name}</div>
          <div className="so-preview-load">
            {SKINS[profile.skin]?.legendary && <span title="Legendary skin">{SKINS[profile.skin].icon}</span>}
            {GADGETS[profile.gadget]?.icon !== '🚫' && <span>Q {GADGETS[profile.gadget]?.icon}</span>}
            {TRAILS[profile.trail]?.icon !== '🚫' && <span>{TRAILS[profile.trail]?.icon}</span>}
            {COSMETICS.effects.find((e) => e.id === profile.effect)?.icon && profile.effect !== 'none' && <span>{COSMETICS.effects.find((e) => e.id === profile.effect)?.icon}</span>}
          </div>
        </div>

        <div className="so-field">
          <label>Name</label>
          <input value={profile.name} onChange={(e) => onChange({ name: (e.target.value || 'Player').slice(0, 14) })}
            maxLength={14} placeholder="Enter name" data-testid="customize-name-input" />
        </div>

        <div className="so-shop-tabs">
          {CATS.map((c) => (
            <button key={c.key} className={tab === c.key ? 'on' : ''} onClick={() => setTab(c.key)} data-testid={'shop-tab-' + c.key}>{c.label}</button>
          ))}
        </div>

        {cat.free ? (
          <div className="so-swatches">
            {SKIN_COLORS.map((c) => (
              <button key={c} className={'so-swatch' + (c === profile.color ? ' sel' : '')}
                style={{ background: c }} onClick={() => onChange({ color: c })} data-testid={'color-' + c.replace('#', '')} />
            ))}
          </div>
        ) : (
          <div className="so-shop-grid" data-testid={'grid-' + cat.key}>
            {cat.items.map((item) => {
              const ownedIt = isOwned(cat.key, item.id);
              const equipped = profile[cat.field] === item.id;
              const locked = item.exclusive && !ownedIt;
              const afford = (profile.coins || 0) >= item.price;
              const cls = 'so-shop-item' + (equipped ? ' equipped' : '') + (locked ? ' locked' : (!ownedIt && !afford ? ' cantafford' : '')) + (item.legendary ? ' legendary' : '') + (item.exclusive ? ' exclusive' : '');
              return (
                <button key={item.id} className={cls} title={item.desc || ''} data-testid={cat.key + '-' + item.id}
                  onClick={() => buy(cat.key, cat.field, item)}>
                  <span className="ic">{item.icon || '🎨'}</span>
                  <small>{item.name}</small>
                  {ownedIt ? <small className="price">{equipped ? 'EQUIPPED' : 'EQUIP'}</small>
                    : locked ? <small className="price store">🛒 STORE</small>
                    : <small className="price">🪙 {item.price}</small>}
                </button>
              );
            })}
          </div>
        )}

        {cat.items && cat.items.find((i) => i.id === profile[cat.field])?.desc && (
          <div className="so-item-desc">{cat.items.find((i) => i.id === profile[cat.field]).desc}</div>
        )}

        <button className="so-btn-play" onClick={onBack} data-testid="customize-save">Done</button>
      </div>
    </div>
  );
}
